<style>
.bill-filter-wrapper .foodcompany-filter-input{
	float: right;
	width: 70%;
	position: relative;
    top: -7px;
	text-overflow: ellipsis;
	background-image: url('../assets/listview-arrow.jpg');
	background-repeat: no-repeat;
	background-position: 100%;
	color: #666;
}
.foodcompany-filter-wrapper{
	position: absolute;
	width: 100%;
	height: 100%;
	top:0;
	right:0;
	background-color: #ececec;
	border-left: solid 1px #aaa;
}
.edi-allorderbill .foodcompany-filter-wrapper .ui-listview{
	width: 100%;
	background-color: #fff;
	margin-bottom: .7em;
}
.edi-allorderbill .foodcompany-filter-wrapper .ui-listview > li{
	    margin: 0em .4em;
	    padding: .4em 2em .4em 1em;
	    box-sizing: border-box;
}
.edi-allorderbill .foodcompany-filter-wrapper .ui-listview > li:last-child{
	   /* border-bottom:none;*/
}
.edi-allorderbill .foodcompany-filter-wrapper .ui-listview > li label{
	display: block;
}
.edi-allorderbill .foodcompany-filter-wrapper .ui-listview > li input[type="checkbox"]{
	float: right;
	position: relative;	
	top: .2em;
	right:1em;
}
.edi-allorderbill .foodcompany-filter-wrapper .ui-listview > li input[type="checkbox"]:after{
	content: '';
	position: absolute;
	width: 20px;
	height: 20px;
	background-color: #fff;
	top: -4px;
	left: -2px;
}
.edi-allorderbill .foodcompany-filter-wrapper .ui-listview > li input[type="checkbox"]:checked:after{
	content: url('../assets/allorderbill/check-mid.png');
	position: absolute;
	top: -4px;
	left: -2px;
}
.foodcompany-filter-wrapper	.letter-ullist{
	top:4em;
}
.company-left-move{
	left: 0%;
	animation: companyLeftMove .2s ease-out;
	-webkit-animation: companyLeftMove .2s ease-out;
}
.company-right-move{
	left: 100%;
	animation: companyRightMove .2s ease-out;
	-webkit-animation: companyRightMove .2s ease-out;
}
.foodcompany-loading{
	position: absolute;
	left: 50%;
	top: 50%;
	width: 50px;
	height: 50px;
	margin: -25px 0 0 -25px;
	text-align: center;
	background-color: greenyellow;
}
.restaurant-name{
	position: absolute;
	width: 60%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	color: #666;
}
@keyframes companyLeftMove {
  0% {
    left: 100%;
  }
  100% {
    left: 0%;
  }
}
@keyframes companyRightMove {
  0% {
    left: 0%;
  }
  100% {
    left: 100%;
  }
}
@-webkit-keyframes companyLeftMove {
  0% {
    left: 100%;
  }
  100% {
    left: 0%;
  }
}
@-webkit-keyframes companyRightMove {
  0% {
    left: 0%;
  }
  100% {
    left: 100%;
  }
}

</style>
<template>
	<div class="bill-filter-listdiv" style="padding: .8em .8em 1em;">餐企筛选:
		<input type="hidden" class="restaurant-name" v-model="restaurantId"/>
		<input type="text" v-model="restaurantName" readonly="true" class="foodcompany-filter-input"  @click="modifyClassL">
		<div class="foodcompany-filter-wrapper" :class="{'company-right-move':isNone,'company-left-move':!isNone}">
			<div class="default">
				<div class="bill-filter-listdiv bill-filter-first text-mid" style="margin-bottom: 0">
					<a class="bill-filter-confirm" @click="modifyClassR">确定</a>
					<span style="position: relative; top: .5em">餐企筛选</span>
				</div>
				<div class="list-container" v-for = "(restaurantDetail, index) in restaurantDetails">
					<p class="letter-flag" :id="restaurantDetail.phonetic" v-if="hasAlpha(restaurantDetail)">
						{{restaurantDetail.phonetic}}
					</p>
					<ul class="ui-listview" style="margin-bottom: 0;padding-bottom: 0">
						<li>
							<label :for="restaurantDetail.restaurant_id">{{restaurantDetail.name}}
								<input type="checkbox" name="restaurant" :id="restaurantDetail.restaurant_id" v-if="selectJudge(restaurantDetail.restaurant_id)" @click.stop="selectId(restaurantDetail.restaurant_id,restaurantDetail.name)" checked/>
								<input type="checkbox" name="restaurant" :id="restaurantDetail.restaurant_id" v-else @click.stop="selectId(restaurantDetail.restaurant_id,restaurantDetail.name)"/>
							</label>
						</li>
					</ul>
				</div>
				<mid-ware v-show="midware" :icon="icon" :midFont="midFont"></mid-ware>
				<spin v-show="spin"></spin>
			</div>
			<div>
				<ul class="letter-ullist" v-show = "letterShow">
					<li><a href="##">#</a></li>
					<li v-for="(letter, index) in letters">
						<a :href="anchor(letter)">{{letter}}</a>
					</li>
				</ul>
			</div>
		</div>	
	</div>
</template>

<script>
import MidWare from '../components/MidWare'
import spin from '../components/spin'
var oldAlpha = ''

export default {
	props: {
		restaurantId: String,
		restaurantName: String
	},
	data () {
		return {
			midware: false,
			spin: true,
			icon: 'middle-net',
			midFont: '服务中断，请重试！',
			isNone: true,
			letterShow: false,
			selectArr: [],
			selectName: this.restaurantName,
			selectNameStr: '',
			restaurantDetails: {},
			letters: []
		}
	},
	created () {
		// window.console.log(this.restaurantId)
		// window.console.log(this.restaurantName)
		// window.console.log(this.selectName)
	},
	components: {
		'mid-ware': MidWare,
		'spin': spin
	},
	methods: {
		anchor (val) {
			return '#' + val
		},
		hasAlpha (item) {
			var b = item.phonetic !== oldAlpha
			oldAlpha = item.phonetic
			return b
		},
		modifyClassL () {
			this.letters = []
			this.isNone = false
			this.midware = false
			this.spin = true
			// this.selectName = this.selectName.join(',')
			// this.restaurantId = this.selectArr.join(',')
			if (this.selectName === '') {
				this.selectName = []
			} else {
				this.selectName = this.restaurantName.split(',')
			}
			if (this.restaurantId === '') {
				this.restaurantId = []
			} else {
				this.restaurantId = this.restaurantId.split(',')
			}
			// window.console.log(this.restaurantId)
			// window.console.log(this.selectName)
			this.$http.get('/cldEdi/business/getRestraurantList').then((response) => {
				if (response.body.result) {
					this.letterShow = true
					this.midware = false
					this.spin = false
					this.restaurantDetails = response.body.data
					this.letterFilter()
				} else {
					this.spin = false
					this.midware = true
					this.midFont = response.data.message
				}
			}, (response) => {
				this.midware = true
				this.spin = false
			})
		},
		modifyClassR () {
			this.isNone = true
			this.midware = false
			this.spin = false
			this.selectName = this.selectName.join(',')
			this.restaurantId = this.restaurantId.join(',')
			var str = this.restaurantId + '|' + this.selectName
			// window.console.log(str)
			this.$emit('modifyClassR', str)
		},
		selectId (val1, val2) {
			var index = this.restaurantId.indexOf(val1)
			if (index === -1) {
				this.restaurantId.push(val1)
				this.selectName.push(val2)
				// window.console.log(this.selectName)
				return false
			} else {
				this.restaurantId.splice(index, 1)
				this.selectName.splice(index, 1)
				// window.console.log(this.selectName)
				return false
			}
		},
		letterFilter () {
			var data = this.restaurantDetails
			for (var i = 0; i < data.length; i++) {
				if (this.letters.indexOf(data[i].phonetic) === -1) {
					this.letters.push(data[i].phonetic)
				}
			}
		},
		selectJudge (val) {
			if (this.restaurantId.indexOf(val) !== -1) {
				return true
			} else {
				return false
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// FoodCompanyFilter.vue?6a06ebb8